import { useTranslation } from "react-i18next";
import { Link } from "@tanstack/react-router";
import clsx from "clsx";
import { type LucideIcon } from "lucide-react";
import { SuperUserPermissionsEnum } from "@/client-admin";
import { Collapsible } from "@/components/ui/collapsible";
import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";
import { Permission } from "@/lib/utils";

export type NavItem = {
  title: string;
  url: string;
  icon: LucideIcon;
  permission: Permission | SuperUserPermissionsEnum;
};

export function NavMain({ items }: { items: NavItem[] }) {
  const { t } = useTranslation();
  return (
    <SidebarGroup>
      <SidebarGroupLabel>Platform</SidebarGroupLabel>
      <SidebarMenu>
        {items.map((item) => (
          <Collapsible key={item.title} asChild className="group/collapsible">
            <SidebarMenuItem>
              <SidebarMenuButton tooltip={t(item.title)} asChild>
                <Link to={item.url}>
                  {({ isActive }: { isActive: boolean }) => (
                    <>
                      {item.icon && (
                        <item.icon
                          className={clsx("h-4 w-4 transition-all", {
                            "font-extrabold text-primary": isActive,
                            "text-muted-foreground hover:text-primary": !isActive,
                          })}
                        />
                      )}
                      <span
                        className={clsx("transition-all", {
                          "font-extrabold text-primary": isActive,
                          "text-muted-foreground hover:text-primary": !isActive,
                        })}
                      >
                        {t(item.title)}
                      </span>
                    </>
                  )}
                </Link>
              </SidebarMenuButton>
            </SidebarMenuItem>
          </Collapsible>
        ))}
      </SidebarMenu>
    </SidebarGroup>
  );
}
